import { postForgottenPassword, postResendOtp } from '../services/authservices';
import { ForgotPassoword } from '../constant/serviceType';

export const forgotPasswordMethod = async (payload: ForgotPassoword) => {
  let userResponse = null;
  try {
    const response = await postForgottenPassword(payload);
    // console.log('registerUser', response);
    userResponse = response?.data?.data;
    if (userResponse) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const { access_token } = userResponse;
      return { success: true, data: access_token };
    }
  } catch (e: any) {
    console.log(e.response.data.error);
    return { success: false, error: e.response?.data?.error };
  }

  return userResponse;
};


export const resendOtp = async (payload: ForgotPassoword) => {
  let userResponse = null;
  try {
    const response = await postResendOtp(payload);
    console.log('resend', response);
    userResponse = response?.data?.data;
    if (userResponse) {
      return { success: true };
    }
  } catch (e: any) {
    console.log(e.response.data.error);
    return { success: false, error: e.response?.data?.error };
  }

  return userResponse;
};
